import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit").then(({ data }) => setLogs(data.logs)).catch(() => {}); }, []);

  return (
    <div data-testid="admin-audit">
      <h1 className="font-serif text-3xl font-semibold text-forest">Audit log</h1>
      <p className="mt-2 text-sm text-charcoal/70 max-w-2xl leading-relaxed">
        A record of significant administrative and security events. Passwords, tokens and
        authentication links are never recorded here.
      </p>
      <div className="mt-6 bg-white border border-sandstone overflow-x-auto">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead>
            <tr className="text-left border-b border-sandstone text-xs uppercase tracking-wider text-charcoal/60">
              <th className="px-5 py-3 font-semibold">Time (UTC)</th>
              <th className="px-5 py-3 font-semibold">Action</th>
              <th className="px-5 py-3 font-semibold">Actor</th>
              <th className="px-5 py-3 font-semibold">Detail</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-b border-sandstone/60 last:border-0">
                <td className="px-5 py-3 text-charcoal/60 whitespace-nowrap">{new Date(l.ts).toLocaleString("en-GB")}</td>
                <td className="px-5 py-3 font-mono text-xs">{l.action}</td>
                <td className="px-5 py-3">{l.actor}</td>
                <td className="px-5 py-3 text-charcoal/70">{l.detail || "—"}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={4} className="px-5 py-6 text-center text-charcoal/50">No events recorded yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
